export default __webpack_public_path__ + "static/media/no-access.65633c22.webp";